import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata"

const Seo = ({ title, description, keywords, ogTitle, ogDescription, ogType, ogSiteName, ogImage, twitterCard, twitterCreator, twitterTitle, twitterDescription, twitterImage, children }) => {
  const { title: defaultTitle, description: defaultDescription, author: defaultAuthor, siteUrl } = useSiteMetadata()
  const ogUrl = typeof window !== 'undefined' ? window.location.pathname : null;
  const ogSiteNameDefault = `Yellosoft`;
  const ogTypeDefault = `article`;
  const twitterCardDefault = `summary_large_image`;
  const defaultKeywords = `Taxi Booking Software`;

  const seoMeta = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    keywords: keywords || defaultKeywords,
    ogTitle: ogTitle || title,
    ogDescription: ogDescription || description,
    ogType: ogType || ogTypeDefault,
    ogUrl: `${siteUrl}${ogUrl}`,
    ogSiteName: ogSiteName || ogSiteNameDefault,
    ogImage: `${siteUrl}${ogImage}`,
    twitterCard: twitterCard || twitterCardDefault,
    twitterCreator: twitterCreator || defaultAuthor,
    twitterTitle: twitterTitle || title,
    twitterDescription: twitterDescription || description,
    twitterImage: `${siteUrl}${twitterImage}`,
  }
  const schemaOrgJSONLD = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Yelowsoft",
    "description": `${defaultDescription}`,
    "alternateName": "Yelowsoft.com",
    "url": `${siteUrl}`,
    "logo": `${siteUrl}/logo.svg`,
    "sameAs": [
      "https://www.facebook.com/yelowsoft",
      "https://twitter.com/yelowsoft",
      "https://www.linkedin.com/company/13587119",
      "https://in.pinterest.com/yelowsoft",
      "https://www.instagram.com/yelowsoft/?hl=en",
      "https://www.youtube.com/channel/UCKrrVHIZ1EefGKiZ_DPa_8A"
    ]
  }

  return (
    <>
      <title>{seoMeta.title}</title>
      <meta name="description" content={seoMeta.description} />
      <meta name="keywords" content={seoMeta.keywords} />
      <meta name="og:title" content={seoMeta.ogTitle} />
      <meta name="og:description" content={seoMeta.ogDescription} />
      <meta name="og:type" content={seoMeta.ogType} />
      <meta name="og:url" content={seoMeta.ogUrl} />
      <meta name="og:site_name" content={seoMeta.ogSiteName} />
      <meta name="og:image" content={seoMeta.ogImage} />
      <meta name="twitter:card" content={seoMeta.twitterCard} />
      <meta name="twitter:creator" content={seoMeta.twitterCreator} />
      <meta name="twitter:title" content={seoMeta.twitterTitle} />
      <meta name="twitter:description" content={seoMeta.twitterDescription} />
      <meta name="twitter:image" content={seoMeta.twitterImage} />
      {/* <meta name="robots" content="noindex, nofollow" /> */}
      <meta name="google-site-verification" content="googleea10d1906c0b8ac0" />
      {children}
      <script type='application/ld+json'>
        {JSON.stringify(schemaOrgJSONLD)}
      </script>
    </>
  )
}

export default Seo;